import CampaignZoom from "../../Components/CampaignZoom";
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { campaignVanitas } from "../../Utils/CampaignDefinitions";

const Vanitas = () => {
  const [fullScreenPicture, setFullScreenPicture] = useState<
    string | undefined
  >(undefined);
  const picList = [
    "/vanitas/Vanitas1.jpg",
    "/vanitas/Vanitas2.jpg",
    "/vanitas/Vanitas3.jpg",
    "/vanitas/Vanitas4.jpg",
    "/vanitas/Vanitas5.jpg",
    "/vanitas/Vanitas6.jpg",
    "/vanitas/Vanitas7.jpg",
    "/vanitas/Vanitas8.jpg",
    "/vanitas/Vanitas9.jpg",
    "/vanitas/Vanitas10.jpg",
    "/vanitas/Vanitas11.jpg",
    "/vanitas/Vanitas12.jpg",
    "/vanitas/Vanitas13.jpg",
  ];

  const [scrollPosition, setScrollPosition] = useState<number>(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleScroll = () => {
    window.scrollTo(0, scrollPosition);
  };

  const renderVerticalRange = (range: string[]) => (
    <div className="campaignPicRange pointer">
      {range.map((picture, key) => (
        <img
          key={key}
          aria-label="Campaign Vanitas squillace 1923 leather gloves"
          className="campaignPicVerticalKatabasis"
          src={`/vanitas/${picture}`}
          alt={`campaign ${campaignVanitas.title} squillace1923 gloves`}
          onClick={() => {
            setScrollPosition(window.pageYOffset);
            setFullScreenPicture(`/vanitas/${picture}`);
          }}
        />
      ))}
    </div>
  );

  const renderHorizontalRange = (range: string) => (
    <div className="campaignPicRange">
      <img
        key={3}
        aria-label="Campaign Vanitas squillace 1923 leather gloves"
        className="campaignPicHorizontal pointer"
        src={`/vanitas/${range}`}
        alt={`campaign ${campaignVanitas.title} squillace1923 gloves`}
        onClick={() => {
          setScrollPosition(window.pageYOffset);
          setFullScreenPicture(`/vanitas/${range}`);
        }}
      />
    </div>
  );
  const ranges = campaignVanitas.pictureRanges;

  return (
    <div className="content">
      <Helmet>
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1"
        ></meta>
        <title>
          Squillace 1923 - Luxury leather gloves campaign handmade in Italy -
          Vanitas season 23
        </title>

        <meta
          name="description"
          content="Squillace 1923 is the Haute Couture brand by Omega srl. 
    Luxurious and elegant leather gloves collections, made in Naples following the ancestral phases of production, entirely handmade."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <div className="title">
        <h1>{campaignVanitas.title.toUpperCase()}</h1>
        <h2>
          {campaignVanitas.description.map((text, index) => (
            <>
              {text}
              <br></br>
              <br></br>
            </>
          ))}
        </h2>
      </div>
      <div className="campaignPic">
        {renderHorizontalRange(ranges.firstRange)}
        {renderVerticalRange(ranges.secondRange)}
        {renderVerticalRange(ranges.thirdRange)}
        {renderVerticalRange(ranges.fourthRange)}
        {renderVerticalRange(ranges.fifthRange)}
        {renderVerticalRange(ranges.sixthRange)}
        {renderVerticalRange(ranges.seventhRange)}
      </div>

      {fullScreenPicture && (
        <CampaignZoom
          picList={picList}
          fullScreenPicture={fullScreenPicture}
          setFullScreenPicture={setFullScreenPicture}
          handleScroll={handleScroll}
        />
      )}
    </div>
  );
};

export default Vanitas;
